var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodes = function SvgCodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 89"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 79,
    width: 128,
    height: 10,
    rx: 1,
    ry: 1,
    fill: "#dcdcdc",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 118,
    height: 79,
    rx: 1,
    ry: 1,
    fill: "#5700d1",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 9,
    width: 99,
    height: 61,
    fill: "#fff",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 79,
    width: 17,
    height: 5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 53,
    width: 32,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 43,
    width: 39,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 33,
    width: 58,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 23,
    width: 12,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 23,
    width: 43,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#9e9e9e",
    strokeWidth: 0
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 23,
    width: 6,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#8051ff",
    strokeWidth: 0
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 43,
    width: 6,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#8051ff",
    strokeWidth: 0
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 53,
    width: 6,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#8051ff",
    strokeWidth: 0
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 33,
    width: 6,
    height: 3,
    rx: 1.5,
    ry: 1.5,
    fill: "#8051ff",
    strokeWidth: 0
  })));
};
export default SvgCodes;